import { renewToken } from "../actions/auth";
import axios from "../lib/axios";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";
import { requestRecommendedLeadForm } from "../utils/recommendedLeadForm";

const ENDPOINT = "generateRecommendedLeadFormAdsCampaigns";

export const generateRecommendedLeadForm = ({
  dispatch,
  body,
  campaignID,
  platform,
}) =>
  requestRecommendedLeadForm({
    key: `${campaignID}:${platform}`,
    body,
    post: async ({ body: requestBody, timeout }) => {
      const token = await dispatch(renewToken());
      return axios({
        method: "post",
        url: `${getCloudFunctionUrl(ENDPOINT)}/${ENDPOINT}`,
        data: requestBody,
        timeout,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
  });
